import React, { useEffect } from 'react';
import { mergeCopy } from '../../../utils/cms_copy_provider';
import { LoginClick, LogoutClick, RegisterClick } from './login';

import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../../../Store';

const WelcomeTemplate = ({ user, children, actions }) => {
    //* load player data when no name to display
    useEffect(() => {
        if (user.loggedIn && !user.player.firstname) {
            actions.userActions.getPlayerData();
        }
    }, []);

    const renderName = (user) => {
        if (user.loggedIn) {
            return (
                <p>
                    <span className='welcome-text'>Welcome,</span>
                    <span className='user-name'>{user.player.firstname}!</span>
                </p>
            );
        } else {
            return (
                <p>
                    <span className='welcome-text'>Welcome!</span>
                </p>
            );
        }
    };

    return (
        <div className='welcome'>
            {renderName(user)}
            {children}
        </div>
    );
};

const Welcome = connect(mapStateToProps, mapDispatchToProps)(WelcomeTemplate);

const LogoutButtonTemplate = ({ user, config, actions, copy = {}, children }) => {
    const defaultCopy = {
        welcome: {
            logout: 'Log Out',
        },
    };

    const usedCopy = mergeCopy(defaultCopy, copy);

    const logoutAction = LogoutClick(config, actions);

    const logoutClick = async (e) => {
        logoutAction();
        e.preventDefault();
    };

    if (user.loggedIn) {
        return (
            <a
                tabIndex={0}
                role='button'
                className='btn theme-btn theme-gray logout'
                onClick={logoutClick}
                onKeyDown={(e) => e.key === 'Enter' && logoutClick(e)}>
                {children || usedCopy.welcome.logout}
            </a>
        );
    } else {
        return null;
    }
};

const LogoutButton = connect(mapStateToProps, mapDispatchToProps)(LogoutButtonTemplate);

const LoginButtonTemplate = ({ user, config, copy = {}, children }) => {
    const defaultCopy = {
        welcome: {
            login: 'Log In',
        },
    };

    const usedCopy = mergeCopy(defaultCopy, copy);

    const loginAction = LoginClick(config);

    const loginClick = async (e) => {
        loginAction();
        e.preventDefault();
    };

    if (user.loggedIn) {
        return null;
    } else {
        return (
            <a tabIndex={0} role='button' onClick={loginClick} onKeyDown={(e) => e.key === 'Enter' && loginClick(e)} className='btn theme-btn theme-blue login'>
                {children || usedCopy.welcome.login}
            </a>
        );
    }
};

const LoginButton = connect(mapStateToProps, mapDispatchToProps)(LoginButtonTemplate);

const RegisterButtonTemplate = ({ user, config, copy = {}, children }) => {
    const defaultCopy = {
        welcome: {
            register: 'Register',
        },
    };

    const usedCopy = mergeCopy(defaultCopy, copy);

    const registerAction = RegisterClick(config);

    const registerClick = async (e) => {
        registerAction();
        e.preventDefault();
    };

    if (user.loggedIn) {
        return null;
    } else {
        return (
            <a
                tabIndex={0}
                role='button'
                className='btn theme-btn theme-gray register'
                onClick={registerClick}
                onKeyDown={(e) => e.key === 'Enter' && registerClick(e)}>
                {children || usedCopy.welcome.register}
            </a>
        );
    }
};

const RegisterButton = connect(mapStateToProps, mapDispatchToProps)(RegisterButtonTemplate);

const AccountButtonTemplate = ({ user, copy = {}, children }) => {
    const defaultCopy = {
        welcome: {
            account: 'Account',
        },
    };

    const usedCopy = mergeCopy(defaultCopy, copy);

    if (user.loggedIn) {
        return (
            <a href='/my-profile' className='btn theme-btn theme-blue account'>
                {children || usedCopy.welcome.account}
            </a>
        );
    } else {
        return null;
    }
};

const AccountButton = connect(mapStateToProps, mapDispatchToProps)(AccountButtonTemplate);

export { AccountButton, LoginButton, LogoutButton, RegisterButton, Welcome };
